import { useMocks } from '../../shared/env';
import type { PayrollReviewGateway } from './PayrollReviewGateway';
import { HttpPayrollReviewGateway } from './HttpPayrollReviewGateway';
import { MockPayrollReviewGateway } from './MockPayrollReviewGateway';

export const payrollReviewGateway: PayrollReviewGateway = useMocks ? new MockPayrollReviewGateway() : new HttpPayrollReviewGateway();
export type { PayrollReviewGateway } from './PayrollReviewGateway';
